import { atom } from "recoil";
import { Asset } from "../../AssetOverview";

export const assetTagModalLoadingAtom = atom<boolean | undefined>({
  key: "assetTagModalLoadingAtom",
  default: undefined,
});

export const assignedAssetTagErrorAtom = atom<string | undefined>({
  key: "assignedAssetTagErrorAtom",
  default: undefined,
});
